import { graphql } from '@repo/common/queries/helpers/server_query'

export const query_get_helpscout = graphql(`
  query get_helpscout {
    me {
      helpscout_signature
    }
  }
`)
